// TeacherInformationSection.js
import { useState, useEffect } from "react"
import { Grid, InputAdornment } from "@mui/material"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import { useLazyGetVisaLXOQuery } from "shared/redux/endpoints/lxo"
import { Loading } from "shared/components/ui/Loading"
import MDInput from "components/MDInput"
import SearchIcon from "@mui/icons-material/Search"
import ReactPaginate from "react-paginate"
import { useSelector } from "react-redux"

const TABLE_HEADERS = [
  { Header: "Full Name", accessor: "fullName", width: "200px" },
  { Header: "Email", accessor: "email", width: "250px" },
  { Header: "Employee Code", accessor: "employeeCode" },
  { Header: "Employee Status", accessor: "employeeStatus" },
  { Header: "User ID", accessor: "userId" },
  { Header: "User Code", accessor: "userCode" },
  { Header: "Latest Job Title (EN)", accessor: "latestJobTitleEn" },
  { Header: "Latest Job Title (VN)", accessor: "latestJobTitleVn" },
  { Header: "Center ID", accessor: "centerId" },
  { Header: "ID Card Issuing Place", accessor: "idCardIssuingPlaceCode" },
  { Header: "ID Card Issue Date", accessor: "idCardIssueDate" },
  { Header: "Passport Issue Date", accessor: "passportIssueDate" },
  { Header: "Passport Effective Date", accessor: "passportEffectiveDate" },
  { Header: "Visa Number", accessor: "visaNumber" },
  { Header: "Visa Effective Date", accessor: "visaEffectiveDate" },
  { Header: "Visa Issuing Place", accessor: "visaIssuingPlace" },
  {
    Header: "Temporary Residence Card Effective Date",
    accessor: "temporaryResidenceCardEffectiveDate",
  },
  {
    Header: "Temporary Residence Card Number",
    accessor: "temporaryResidenceCardNumber",
  },
  { Header: "Work Permit Issuing Place", accessor: "workPermitIssuingPlace" },
  { Header: "Labor Permit Number", accessor: "laborPermitNumber" },
]

export default function TeacherManagementInformationSection() {
  // State management matching CenterDashboardSection
  const auth = useSelector((state) => state.auth)
  const centerId = auth.centerId
  const [state, setState] = useState({
    page: 0,
    size: 10,
    keyword: "",
    centerId,
  })
  const [isLoading, setIsLoading] = useState(true)
  const [dataTable, setDataTable] = useState({
    columns: TABLE_HEADERS,
    rows: [],
  })
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 0,
  })

  const [trigger] = useLazyGetVisaLXOQuery()

  const handlerDataTable = (data) => {
    const display = (value) =>
      value === null || value === undefined || value === "" ? "-" : value

    setDataTable({
      columns: TABLE_HEADERS,
      rows: data?.data
        ? data?.data?.map((item) => ({
            fullName: <MDTypography>{display(item.fullName)}</MDTypography>,
            email: <MDTypography>{display(item.email)}</MDTypography>,
            avatar: <MDTypography>{display(item.avatar)}</MDTypography>,
            centerId: <MDTypography>{display(item.centerId)}</MDTypography>,
            phoneNumber: (
              <MDTypography>{display(item.phoneNumber)}</MDTypography>
            ),
            employeeCode: (
              <MDTypography>{display(item.employeeCode)}</MDTypography>
            ),
            employeeStatus: (
              <MDTypography>{display(item.employeeStatus)}</MDTypography>
            ),
            visaNumber: <MDTypography>{display(item.visaNumber)}</MDTypography>,
            userId: <MDTypography>{display(item.userId)}</MDTypography>,
            userCode: <MDTypography>{display(item.userCode)}</MDTypography>,
            latestJobTitleEn: (
              <MDTypography>{display(item.latestJobTitleEn)}</MDTypography>
            ),
            idCardIssuingPlaceCode: (
              <MDTypography>
                {display(item.idCardIssuingPlaceCode)}
              </MDTypography>
            ),
            idCardIssueDate: (
              <MDTypography>{display(item.idCardIssueDate)}</MDTypography>
            ),
            passportIssueDate: (
              <MDTypography>{display(item.passportIssueDate)}</MDTypography>
            ),
            passportEffectiveDate: (
              <MDTypography>{display(item.passportEffectiveDate)}</MDTypography>
            ),
            temporaryResidenceCardEffectiveDate: (
              <MDTypography>
                {display(item.temporaryResidenceCardEffectiveDate)}
              </MDTypography>
            ),
            visaEffectiveDate: (
              <MDTypography>{display(item.visaEffectiveDate)}</MDTypography>
            ),
            visaIssuingPlace: (
              <MDTypography>{display(item.visaIssuingPlace)}</MDTypography>
            ),
            workPermitIssuingPlace: (
              <MDTypography>
                {display(item.workPermitIssuingPlace)}
              </MDTypography>
            ),
            laborPermitNumber: (
              <MDTypography>{display(item.laborPermitNumber)}</MDTypography>
            ),
            temporaryResidenceCardNumber: (
              <MDTypography>
                {display(item.temporaryResidenceCardNumber)}
              </MDTypography>
            ),
            latestJobTitleVn: (
              <MDTypography>{display(item.latestJobTitleVn)}</MDTypography>
            ),
          }))
        : [],
    })
  }

  const handlderAPIList = (params) => {
    trigger(params).then((res) => {
      handlerDataTable(res?.data?.data)
      setPagination({
        ...pagination,
        totalPage: res?.data?.data?.totalPage,
        currentPage: res?.data?.data?.currentPage,
      })
      setIsLoading(false)
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setState((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleChangePage = (page) => {
    handlderAPIList({
      ...state,
      page: page,
    })
  }

  // Fetch data when filters change
  useEffect(() => {
    setTimeout(() => {
      handlderAPIList(state)
    }, 1000)
  }, [])

  useEffect(() => {
    handlderAPIList({ ...state, centerId })
  }, [centerId])

  return (
    <Grid
      item
      xs={12}
      lg={8}
      xxl={7.5}
      className={`teacher-management__section`}
    >
      {isLoading ? (
        <Loading style={{ height: 200, margin: "10% auto" }} />
      ) : (
        <MDBox className="teacher-management__table">
          <MDBox className="teacher-management__table-header">
            {/* <InfoIcon
              type={TooltipType.TYPE_1}
              content={`Teacher Information is a list of teacher information.`}
              color={TooltipIconColor.BLUE}
            >
              <MDTypography variant="h3" className="info-icon__title">
                Teacher Information
              </MDTypography>
            </InfoIcon> */}
            <MDTypography variant="h3" className="info-icon__title">
              Teacher Information
            </MDTypography>
          </MDBox>

          {/* <MDBox className="teacher-management__table-filters">
            <MDInput
              className="input input-search"
              placeholder="Search here..."
              name="keyword"
              value={state.keyword}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="icon-search" />
                  </InputAdornment>
                ),
              }}
              onChange={handleInputChange}
            />
          </MDBox> */}
          <MDBox className="teacher-management__table-wrapper">
            <DataTable
              table={dataTable}
              entriesPerPage={{
                isShown: true,
                defaultValue: state.size,
                entries: [5, 10, 25],
                pagination: true,
              }}
            />
            <MDBox className="table-footer">
              <MDBox className="table-footer-showing">
                Showing {dataTable?.rows?.length} of {dataTable?.rows?.length}{" "}
                entries
              </MDBox>
              {pagination.totalPage >= 0 && (
                <ReactPaginate
                  className="pagination"
                  nextLabel={<Icon>chevron_right</Icon>}
                  previousLabel={<Icon>chevron_left</Icon>}
                  forcePage={Number(state.page)}
                  onPageChange={(event) => {
                    handleChangePage(event.selected)
                  }}
                  pageCount={pagination.totalPage}
                />
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      )}
    </Grid>
  )
}
